import React from "react";

export default function Dataloader() {
  return <div className="data-loader"></div>;
}
